<ion-app>
  <ion-split-pane when="sm" id="main-content" [class.has-footer]="(user && targetLang && completedTour)  || (!completedTour && userService.touring)">
    <ion-menu  *ngIf="(user && targetLang && completedTour)  || (!completedTour && userService.touring)" contentId="main-content" side="start" type="overlay">
      <ion-header>
        <ion-toolbar>
          <ion-title>{{ 'MENU.TITLE' | translate }}</ion-title>
        </ion-toolbar>
      </ion-header>
      <ion-content>
        <ion-list  *ngIf="(user && targetLang && completedTour) || (!completedTour && userService.touring)" class="menu-list">
          <ion-item id="home-page-button" routerLink="/news">
            <ion-icon name="home" slot="start"></ion-icon>
            <ion-label>{{ 'MENU.HOME' | translate }}</ion-label>
          </ion-item>
          <ion-item routerLink="/news/bookmarks">
            <ion-icon name="bookmark" slot="start"></ion-icon>
            <ion-label>{{ 'MENU.BOOKMARKS' | translate }}</ion-label>
          </ion-item>
          <ion-item id="study-page-button" routerLink="/study">
            <ion-icon src="assets/icon/learning.svg" slot="start"></ion-icon>
            <ion-label>{{ 'MENU.STUDY' | translate }}</ion-label>
          </ion-item>
          <ion-item routerLink="/settings">
            <ion-icon name="settings" slot="start"></ion-icon>
            <ion-label>{{ 'MENU.SETTINGS' | translate }}</ion-label>
          </ion-item>
        </ion-list>
        <ion-list id="topic-bar" class="menu-list">
          <ion-item *ngFor="let topic of topics" [routerLink]="['/news', topic.name]">
            <ion-icon name="newspaper-outline" slot="start"></ion-icon>
            <ion-label *ngIf="(authService.currentUser$ | async) as user">{{ 'TOPIC.' + topic.name | translate }}</ion-label>
          </ion-item>
        </ion-list>
      </ion-content>
    </ion-menu>

    <ion-content>
      <ion-router-outlet></ion-router-outlet>
    </ion-content>
  </ion-split-pane>

  <ion-footer *ngIf="(user && targetLang && completedTour) || (!completedTour && userService.touring)"class="mobile-footer">
      <ion-buttons id="footer-toolbar"  >
        <ion-button id="home-page-button" routerLink="/news"><ion-icon name="home"></ion-icon></ion-button>
        <ion-button routerLink="/news/bookmarks"><ion-icon name="bookmark"></ion-icon></ion-button>
        <ion-button id="study-page-button" routerLink="/study"><ion-icon src="assets/icon/learning.svg"></ion-icon></ion-button>
        <ion-button routerLink="/settings"><ion-icon name="settings"></ion-icon></ion-button>
      </ion-buttons>
  </ion-footer>
</ion-app>